// extracted by mini-css-extract-plugin
export default {"root":"QRCodeModule_root__Varhw","app-content":"QRCodeModule_app-content__VYs2r"};